module.exports = __webpack_public_path__ + "static/media/pic5.1ab26748.jpg";